import { EMetricKey } from '~/types/metric';

export const EXPERIMENT_FIELD = {
  EXPERIMENT_ID: 'experiment_id',
  EXPERIMENT_VARIANT_ID: 'experiment_variant_id',
  VERSION: 'version',
  EXPERIMENT_GROUP_ID: 'experiment_group_id',
} as const;

export type IExperimentFieldValue = (typeof EXPERIMENT_FIELD)[keyof typeof EXPERIMENT_FIELD];

export const CAMPAIGN_LISTING_METRICS: EMetricKey[] = [
  EMetricKey.SESSION,
  EMetricKey.VISITORS,
  EMetricKey.PAGE_VIEWS,
  EMetricKey.ORDERS,
  EMetricKey.REVENUE,
  EMetricKey.CONVERSION_RATE,
  EMetricKey.BOUNCE_RATE,
  EMetricKey.CTR,
  EMetricKey.AVG_TIME_ON_PAGE,
  EMetricKey.ADDED_TO_CART,
  EMetricKey.ADD_TO_CART_RATE,
  EMetricKey.CART_ADDITION,
  EMetricKey.REACHED_CHECKOUT,
  EMetricKey.COMPLETE_CHECKOUT,
  EMetricKey.AOV,
  EMetricKey.RPV,
];

export const CAMPAIGN_BREAKDOWN_FIELDS = [
  'visitor_items',
  'device_items',
  'traffic_source_items',
] as const;

export type ICampaignBreakdownField = (typeof CAMPAIGN_BREAKDOWN_FIELDS)[number];
